(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('credit-factor-settings', {
            parent: 'entity',
            url: '/credit-factor-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.creditFactorSettings.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/credit-factor-settings/credit-factor-settings.html',
                    controller: 'CreditFactorSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                validateSODAndSession: ['ExposureType', function(ExposureType, GlobalValues) {
                    return ExposureType.validateSODAndSession().$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('creditFactorSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('credit-factor-settings-edit', {
            parent: 'credit-factor-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/credit-factor-settings/credit-factor-settings-dialog.html',
                    controller: 'CreditFactorSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['CreditFactorSettings', 'GlobalValues', function(CreditFactorSettings, GlobalValues) {
                                     return CreditFactorSettings.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         .state('credit-factor-settings-todolist', {
            parent: 'dashboard',
            url: '/CreditFactorSettingsToDo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/credit-factor-settings/credit-factor-settings-dialog.html',
                    controller: 'CreditFactorSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('credit-factor-settings', null, { reload: 'credit-factor-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('credit-factor-settings-todolist-resubmit', {
            parent: 'dashboard',
            url: '/CreditFactorSettingsResubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/credit-factor-settings/credit-factor-settings-dialog.html',
                    controller: 'CreditFactorSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('credit-factor-settings', null, { reload: 'credit-factor-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
        .state('credit-factor-settings-auditLog', {
            parent: 'audit-log',
            url: '/CreditFactorSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/credit-factor-settings/credit-factor-settings-dialog.html',
                    controller: 'CreditFactorSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('credit-factor-settings', null, { reload: 'credit-factor-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
          .state('credit-factor-settings-historyReport', {
            parent: 'history-report',
            url: '/CreditFactorSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/credit-factor-settings/credit-factor-settings-dialog.html',
                    controller: 'CreditFactorSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('credit-factor-settings', null, { reload: 'credit-factor-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('credit-factor-settings-report-view', {
            parent: 'entity',
            url: '/credit-factor-settings-report-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.creditFactorSettingsReportView.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/credit-factor-setings-report/credit-factor-settings-report-view.html',
                    controller: 'CreditFactorSettingsReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
               
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('creditFactorSettings');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        
         };
    })();
